import { render, staticRenderFns } from "./PreOrderLimit.vue?vue&type=template&id=d2dd04b6&"
import script from "./PreOrderLimit.vue?vue&type=script&lang=js&"
export * from "./PreOrderLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports